import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { ICartLineInput, IShopifyCart } from '@app/_shared/_models';
import { CartService } from '../../_services/cart.service';
import { PrismicService } from '../../_services/prismic.service';
import { IShoppingCartPage } from './_prismic/shopping-cart';
import { ICheckoutEmail } from '@app/_shared/_models/email/checkout';
import { EmailService } from '@app/_shared/_services';
import { Router } from '@angular/router';
import { safeSessionStorageGetItem } from '../../_helpers/platform.helpers';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatDialogClose, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatMiniFabButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-shopping-cart',
    templateUrl: './shopping-cart.component.html',
    styleUrls: ['./shopping-cart.component.scss'],
    imports: [MatIcon, MatDialogClose, MatDialogTitle, CdkScrollable, MatDialogContent, MatMiniFabButton, NgxSpinnerComponent, AsyncPipe, MatTooltip]
})
export class ShoppingCartComponent implements OnInit, OnDestroy {
  private readonly cartService = inject(CartService);
  private readonly prismicService = inject(PrismicService);
  private readonly spinnerService = inject(NgxSpinnerService);
  private readonly emailService = inject(EmailService);
  private readonly router = inject(Router);

  public spinner$!: Observable<NgxSpinner>;
  public shoppingCartPage!: IShoppingCartPage;
  public cart$!: Observable<IShopifyCart | undefined>;

  public cart: IShopifyCart | undefined;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  ngOnInit(): void {
    this.cart$ = this.cartService.cart$;
    this.spinner$ = this.spinnerService.spinnerObservable;

    this.prismicService.getSingle('shopping_cart')
      .pipe(take(1))
      .subscribe((res: any) => {
        this.shoppingCartPage = {
          hero_image: res.data.hero_image.url
        }
      });

    this.cart$.pipe(takeUntil(this.unsubscribe))
      .subscribe((cart: IShopifyCart | undefined) => {
        if (cart) {
          this.cart = cart;
        }
      });
  }

  async ngOnDestroy(): Promise<void> {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();

    await this.spinnerService.hide();
  }
  public removeItem(line: ICartLineInput): void {
    this.cartService.deleteCartItem(line.variant, line.sellingPlanAllocation?.sellingPlanId ?? '', 1);
  }

  public addItem(line: ICartLineInput): void {
    this.cartService.insertCartItem(line.variant, 1, line.sellingPlanAllocation?.sellingPlanId ?? '');
  }

  public async checkout(): Promise<void> {
    await this.spinnerService.show();

    const checkoutEmail: ICheckoutEmail = {
      email: this.cart?.buyerIdentity?.email ?? '',
      phone: this.cart?.buyerIdentity?.phone ?? '',
      country: this.cart?.buyerIdentity?.countryCode ?? '',
      message: this.cart?.lines?.map(line => `${line.variant?.productTitle} - ${line.quantity}`).join(',') ?? '',
      origin: safeSessionStorageGetItem('trafficSource') ?? 'Organic',
      webpage: `https://mypoolhut.com${this.router.url}`
    };
    this.emailService.sendCheckoutEmail(checkoutEmail)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.cartService.getCartCheckoutUrl();
        },
        error: () => {
          this.cartService.getCartCheckoutUrl();
        }
      });
  }
}
